/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UserAccountSummary } from "./UserAccountSummary";
import {
    UserAccountSummaryFromJSON,
    UserAccountSummaryFromJSONTyped,
    UserAccountSummaryToJSON,
} from "./UserAccountSummary";

/**
 *
 * @export
 * @interface OfferRedemptionDto
 */
export interface OfferRedemptionDto {
    /**
     *
     * @type {number}
     * @memberof OfferRedemptionDto
     */
    offerRedemptionId?: number;
    /**
     *
     * @type {number}
     * @memberof OfferRedemptionDto
     */
    offerId?: number;
    /**
     *
     * @type {string}
     * @memberof OfferRedemptionDto
     */
    code?: string;
    /**
     *
     * @type {Date}
     * @memberof OfferRedemptionDto
     */
    redeemedAt?: Date;
    /**
     *
     * @type {UserAccountSummary}
     * @memberof OfferRedemptionDto
     */
    user?: UserAccountSummary;
}

/**
 * Check if a given object implements the OfferRedemptionDto interface.
 */
export function instanceOfOfferRedemptionDto(
    value: object,
): value is OfferRedemptionDto {
    return true;
}

export function OfferRedemptionDtoFromJSON(json: any): OfferRedemptionDto {
    return OfferRedemptionDtoFromJSONTyped(json, false);
}

export function OfferRedemptionDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OfferRedemptionDto {
    if (json == null) {
        return json;
    }
    return {
        offerRedemptionId:
            json["offerRedemptionId"] == null
                ? undefined
                : json["offerRedemptionId"],
        offerId: json["offerId"] == null ? undefined : json["offerId"],
        code: json["code"] == null ? undefined : json["code"],
        redeemedAt:
            json["redeemedAt"] == null
                ? undefined
                : new Date(json["redeemedAt"]),
        user:
            json["user"] == null
                ? undefined
                : UserAccountSummaryFromJSON(json["user"]),
    };
}

export function OfferRedemptionDtoToJSON(
    value?: OfferRedemptionDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        offerRedemptionId: value["offerRedemptionId"],
        offerId: value["offerId"],
        code: value["code"],
        redeemedAt:
            value["redeemedAt"] == null
                ? undefined
                : value["redeemedAt"].toISOString(),
        user: UserAccountSummaryToJSON(value["user"]),
    };
}
